"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = function styles(theme) {
  return {
    root: {
      padding: 0
    },
    spacer: {
      flex: '1 1 100%'
    },
    actions: {
      color: theme.palette.text.secondary
    }
  };
};

var EnhancedTableToolbar = function EnhancedTableToolbar(_ref) {
  var classes = _ref.classes,
      title = _ref.title,
      tooltip = _ref.tooltip,
      tooltipAction = _ref.tooltipAction;
  return _react["default"].createElement(_Toolbar["default"], {
    className: classes.root
  }, _react["default"].createElement(_Typography["default"], {
    variant: "h6",
    id: "tableTitle"
  }, title), _react["default"].createElement("div", {
    className: classes.spacer
  }), _react["default"].createElement("div", {
    className: classes.actions,
    onClick: tooltipAction
  }, tooltip ? tooltip : null));
};

EnhancedTableToolbar.propTypes = {
  classes: _propTypes["default"].object.isRequired
};

var _default = (0, _styles.withStyles)(styles)(EnhancedTableToolbar);

exports["default"] = _default;